export const noteKeys = {
    OPEN_NOTE_MODAL: 'OPEN_NOTE_MODAL',
    OPEN_FULL_SCREEN_NOTE_MODAL: 'OPEN_FULL_SCREEN_NOTE_MODAL',
    RESET_ZOOM_SLIDER: 'RESET_ZOOM_SLIDER',
}
